import { BookOpen, Timer } from "lucide-react";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { blockAction } from "@/lib/block-actions";
import type { TimeBlock } from "@/lib/db";
import { FocusRunningError, startFocus } from "@/lib/focus";

/**
 * Launches what a planned block is for (5.7): a focus session sized to a
 * focus or task block, or the Study screen for a study block. Renders
 * nothing for breaks and other blocks.
 */
export function BlockStartButton({ block, className }: { block: TimeBlock; className?: string }) {
	const navigate = useNavigate();
	const action = blockAction(block);
	if (!action) return null;

	async function start() {
		if (!action) return;
		if (action.kind === "study") return void navigate("/study");
		try {
			await startFocus({ planned_min: action.minutes, task_id: action.task_id });
		} catch (err) {
			if (err instanceof FocusRunningError) toast.info("A focus session is already running.");
			else return void toast.error("Could not save on this device. Try again.");
		}
		navigate("/focus");
	}

	return (
		<Button variant="outline" className={className ?? "h-11 md:h-9"} onClick={start}>
			{action.kind === "focus" ? <Timer /> : <BookOpen />}
			{action.label}
		</Button>
	);
}
